import { render, staticRenderFns } from "./upload-cropping-pictures.vue?vue&type=template&id=2dfee9d5&"
import script from "./upload-cropping-pictures.vue?vue&type=script&lang=ts&"
export * from "./upload-cropping-pictures.vue?vue&type=script&lang=ts&"
import style0 from "./upload-cropping-pictures.vue?vue&type=style&index=0&id=2dfee9d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports